import { EntityType } from "fond/types";
import { permissionLevels } from "fond/types/permission";

import { boolean, event, oneOf, string } from "../schema-util";

import { noProps } from "./shared";

export const permissions = {
  "permissions.modal.closed": noProps.describe("User closed the share modal."),
  "permissions.modal.opened": event({
    entityType: oneOf(EntityType).describe("The type of resource the permissions modal is opened for"),
  }),
  "permissions.modal.action.save.add": event({
    inheritedPermissionLevel: oneOf(permissionLevels).optional().describe("The previously inherited permission level for the added user"),
    invitedUser: boolean().describe("Whether the added user was invited as a new user"),
    notificationSent: boolean().describe("Whether a notification was sent to users about the permission changes"),
    permissionLevel: oneOf(permissionLevels).describe("Users permission level on the resource"),
  }),
  "permissions.modal.action.save.update": event({
    currentPermissionLevel: oneOf(permissionLevels).describe("Users current permission level before the update"),
    permissionLevel: oneOf(permissionLevels).describe("Users permission was updated to this level"),
  }),
  "permissions.modal.action.save.deleted": noProps,
  "permissions.modal.action.save.invite": event({
    permissionLevel: oneOf(permissionLevels).describe("Users permission level on the resource"),
    notificationSent: boolean().describe("Whether a notification was sent to users about the permission changes"),
  }),
  "permissions.modal.action.list.added": event({
    isSuggestion: boolean().describe("Whether the added user was from the suggestions list"),
    permissionLevel: oneOf(permissionLevels).describe("The initial permission level assigned to the user being added to the list (prior to save)"),
  }),
  "permissions.modal.action.list.sorted": event({
    columnIds: string().array().describe("List of column IDs that have been sorted"),
  }),
  "permissions.modal.action.list.filtered": event({
    columnIds: string().array().describe("List of column IDs that have been filtered"),
  }),
};
